(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-copy-to-clipboard', actionFunc);

    function actionFunc($q, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {

                try {
                    var range = document.createRange();
                    range.selectNode(angular.element(options.className)[0]);
                    window.getSelection().addRange(range);
                    return document.execCommand('copy');
                } catch (err) {
                    console.log('Oops, unable to copy', err);
                    return false;
                }


            }
        };
    }
})();